export enum UserType {
  BUYER = 'buyer',
  SELLER = 'seller'
}
